exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_infoTable_3XRUrK65KKXN6PHp-KbWO {\n  display: table;\n}\n.IA_infoTableRow_ICpvl1RyE59EP2Jy5uiSb a{\n  text-decoration: none;\n}\n.IA_infoTableRow_ICpvl1RyE59EP2Jy5uiSb a:hover{\n  text-decoration: underline;\n}\n.IA_infoTableRow_ICpvl1RyE59EP2Jy5uiSb {\n  display: table-row;\n  height: 22px;\n  width: auto;\n}\n.IA_birthdayContainer_1XXnFtDnBdK22iOpZjyThJ{\n  width: 100%;\n  display: inline-block;\n} \n.IA_birthdayList_3xdyb2mBULRho_oWgrWVQt {\n  display: inline-block;\n}\n.IA_infoTableText_GRRsSSwnCDnCjhtRkIMsh{\nfont-weight: 100;\n}", ""]);

// Exports
exports.locals = {
	"IA_infoTable": "IA_infoTable_3XRUrK65KKXN6PHp-KbWO",
	"IA_infoTableRow": "IA_infoTableRow_ICpvl1RyE59EP2Jy5uiSb",
	"IA_birthdayContainer": "IA_birthdayContainer_1XXnFtDnBdK22iOpZjyThJ",
	"IA_birthdayList": "IA_birthdayList_3xdyb2mBULRho_oWgrWVQt",
	"IA_infoTableText": "IA_infoTableText_GRRsSSwnCDnCjhtRkIMsh"
};